import React, {
    useState,
    useRef,
    useEffect,
    useMemo,
} from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component

import { ErrorBar } from "../../Components/ErrorBar";
import { FtchPlusError, ScenarioUrl_spec, empty_uuid, ftchPlus, getOptions } from "../../App/Account_urls";
import { Box, Paper, Stack } from "@mui/material";
import { moneyFormatter, moneyPennyFormatter, percent0Formatter } from "../../App/GridFormatters";
import { Help_OasGrid } from "../Help/Help_Grids";
import { GoogleAnalyticsEvent } from "../../Components/ga4";
import { GridHeader } from "../../Components/GridHeader";
import { useCallback } from "react";
import { autoSizeStrategy, columnTypes, onHeaderClicked } from "../../Pages/GridScenario";
import { Arrayify } from "../../Functions/utils";


const cd_Year = {
    headerName: "Year",
    field: "Year",
    sort: "asc",
    width: 75,
    pinned: "left",
    type: "age,rightAligned"

};
const cd_Age = {
    headerName: "Age",
    field: "Age",
    width: 65,
    pinned: "left",
    type: "age,rightAligned",
};
const cd_First6TaxYear = {
    headerName: "Tax Year",
    field: "First6.TaxYear",
    columnGroupShow: "open",
    type: "age,rightAligned",
};
const cd_First6Income = {
    headerName: "Income",
    field: "First6.IncomeYear",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};
const cd_First6EmpReduction = {
    headerName: "Emp.Red",
    field: "First6.EmpReduction",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};
const cd_First6Limit = {
    headerName: "Limit",
    field: "First6.Limit",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};
const cd_First6Max = {
    headerName: "Max",
    field: "First6.Max",
    type: "money,rightAligned",
    valueFormatter: moneyPennyFormatter,
};
const cd_First6Clawback = {
    headerName: "Clawback",
    field: "First6.Clawback",
    type: "money,rightAligned",
    valueFormatter: moneyPennyFormatter,
};
const cd_First6Monthly = {
    headerName: "Monthly Benefit",
    field: "First6.Monthly",
    type: "money,rightAligned",
    valueFormatter: moneyPennyFormatter,
};

const cd_Second6TaxYear = {
    headerName: "Tax Year",
    field: "Second6.TaxYear",
    columnGroupShow: "open",
    type: "age,rightAligned",
};
const cd_Second6Income = {
    headerName: "Income",
    field: "Second6.IncomeYear",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};
const cd_Second6EmpReduction = {
    headerName: "Emp.Red",
    field: "Second6.EmpReduction",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};

const cd_Second6Limit = {
    headerName: "Limit",
    field: "Second6.Limit",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};
const cd_Second6Max = {
    headerName: "Max",
    field: "Second6.Max",
    type: "money,rightAligned",
    valueFormatter: moneyPennyFormatter,
};
const cd_Second6Clawback = {
    headerName: "Clawback",
    field: "Second6.Clawback",
    type: "money,rightAligned",
    valueFormatter: moneyPennyFormatter,
};
const cd_Second6Monthly = {
    headerName: "Monthly Benefit",
    field: "Second6.Monthly",
    type: "money,rightAligned",
    valueFormatter: moneyPennyFormatter,
};



const cd_After75Bonus = {
    headerName: "After75Extra",
    field: "After75Bonus",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};
const cd_Benefit = {
    headerName: "Benefit",
    field: "Annual",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};
const cd_Clawback = {
    headerName: "Clawback",
    field: "Clawback",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};

const cd_Percent = {
    headerName: "% Max @ 65",
    field: "PercentMax",
    valueFormatter: percent0Formatter,
    type: "percent,rightAligned"
};


export const oas_columnDefs = [
    cd_Year,
    cd_Age,
    {
        headerName: "First 6 Months",
        groupId: "First 6 Months",
        children: [cd_First6TaxYear, cd_First6EmpReduction, cd_First6Income, cd_First6Limit, cd_First6Max, cd_First6Clawback, cd_First6Monthly],
    },
    {
        headerName: "Second 6 Months",
        groupId: "Second 6 Months",
        children: [cd_Second6TaxYear, cd_Second6EmpReduction, cd_Second6Income, cd_Second6Limit, cd_Second6Max, cd_Second6Clawback, cd_Second6Monthly],
    },
    {
        headerName: "Yearly",
        groupId: "Yearly",
        children: [cd_Clawback, cd_Benefit, cd_Percent],
    },
];




const OasGrid = ({
    clientJson,
    scen_uuid,
    scen_name,
    width,
    height,
    onClose,
    onExpand,
}) => {
    const gridRef = useRef(null);
    const clientData = useRef(null);
    const topRow = useRef(null);
    const [client, setClient] = useState("");
    const [clients, setClients] = useState([]);
    const [dataSets, setDataSets] = useState([]);
    const [dataSet, setDataSet] = useState("");
    const [rowData, setRowData] = useState();
    const [topRowData, setTopRowData] = useState([]);
    const [bottomRowData, setBottomRowData] = useState([]);
    const [showSums, setShowSums] = useState(false);
    const [loading, setLoading] = useState(true)
    const [errmsg, setErrmsg] = useState("")

    const defaultColDef = useMemo(() => ({
        field: "",
        sortable: false,
        resizable: true,
        suppressMovable: true,
        editable: false,
        width: 100,
        type: "rightAligned",
    }));











    const getData = async () => {
        setLoading(true)

        console.log(clientJson);
        if (scen_uuid && scen_uuid !== empty_uuid) {
            console.log(clientJson.Scenario);
            GoogleAnalyticsEvent("grid", "view", "oas", { action: "view", type: "oas" })

            var url = ScenarioUrl_spec(clientJson, scen_uuid, "oas", "");
            ftchPlus(url, getOptions)
                .then((json) => {
                    console.log(json);
                    clientData.current = json.ClientData;
                    topRow.current = json.TopRow
                    setClients(json.Clients);
                    setDataSets(json.DataSets);
                    const cl = json.Clients[0];
                    setClient(cl);
                    const ds = json.DataSets[0];
                    setDataSet(ds);
                    Update(cl, ds);
                    setLoading(false)

                })
                .catch((error) => {
                    console.log(error.message);
                    setErrmsg(error.message)
                    FtchPlusError(error)
                    setLoading(false)

                });
        }
    };

    const btnClientChanged = (value) => {
        setClient(value);
        Update(value, dataSet);
    };

    const btnDataSetChanged = (value) => {
        setDataSet(value);
        Update(client, value);
    };

    // load data from sever
    useEffect(() => {
        setErrmsg("")
        getData();
    }, [clientJson]);


    const onShowSums = (n, v) => {
        setShowSums(v)
        setTopRowData([])
        setBottomRowData([])

        updateSums(v, client, dataSet)
    }

    const updateSums = (show, cl, ds) => {
        if (show) {
            if (topRow.current) {
                topRow.current[cl][ds][0].Year = "Aggregate"
                topRow.current[cl][ds][0].Age = ""
                setTopRowData(Arrayify(topRow.current[cl][ds]));
            }
        }
    }

    const displayShowSums = () => {
        if (topRow.current) {
            return onShowSums
        }
        return null
    }




    const Update = (cl, ds) => {

        //setColumnDefs(clientData.current[cl][ds].Headers);
        setRowData(clientData.current[cl][ds]);
        updateSums(showSums, cl, ds)
    };

    const onRowDataUpdated = useCallback((event) => {
        event.api.autoSizeAllColumns();
    }, []);

    const gridRefFn = () => {
        return gridRef
    }

    return (
        <Paper>
            <Box sx={{ p: 4 }}>
                <Stack spacing={4}>
                    <GridHeader
                        name={"OAS Calculations"}
                        clientJson={clientJson}
                        scenName={scen_name}
                        clients={clients}
                        client={client}
                        onClientChange={btnClientChanged}
                        dataSets={dataSets}
                        dataSet={dataSet}
                        onDataSetChange={btnDataSetChanged}
                        onExpand={onExpand}
                        onClose={onClose}
                        gridRefFn={gridRefFn}
                        showSums={showSums}
                        onShowSums={displayShowSums()}
                    //onShowSums={onShowSums}
                    />

                    <div
                        className="ag-theme-alpine"
                        style={{
                            width: "100%", height: height
                        }}
                    >
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData} // Row Data for Rows
                            pinnedTopRowData={topRowData}
                            pinnedBottomRowData={bottomRowData}
                            rowHeight={32}
                            columnDefs={oas_columnDefs} // Column Defs for Columns
                            defaultColDef={defaultColDef} // Default Column Properties
                            columnTypes={columnTypes}
                            tooltipShowDelay={1200}
                            // animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                            //suppressCellSelection={true}
                            //rowSelection={mode = 'singleRow'}
                            onRowDataUpdated={onRowDataUpdated}
                            autoSizeStrategy={autoSizeStrategy}
                            autoSizePadding={8}
                            onColumnHeaderClicked={onHeaderClicked}
                            loading={loading}


                        // onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                        // overlayNoRowsTemplate={none}
                        />
                    </div>
                    <Help_OasGrid />
                    <ErrorBar error={errmsg} />
                </Stack>
            </Box>
        </Paper >
    );
};

export default OasGrid;
